(function () {
  var counter = 0;

  var PAUSE_SVG =
    '<svg width="10" height="12" viewBox="0 0 10 12" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<rect x="0" y="0" width="3.5" height="12" rx="1"/>' +
    '<rect x="6.5" y="0" width="3.5" height="12" rx="1"/>' +
    '</svg>';

  var PLAY_SVG =
    '<svg width="10" height="12" viewBox="0 0 10 12" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path d="M0 0 L10 6 L0 12 Z"/>' +
    '</svg>';

  function wireBtn(btn, video) {
    function updateBtn() {
      if (video.paused) {
        btn.setAttribute('aria-label', 'Play video');
        btn.innerHTML = PLAY_SVG;
        btn.classList.add('ada-video-pause-btn--paused');
      } else {
        btn.setAttribute('aria-label', 'Pause video');
        btn.innerHTML = PAUSE_SVG;
        btn.classList.remove('ada-video-pause-btn--paused');
      }
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', updateBtn);
    video.addEventListener('pause', updateBtn);
  }

  function sanitizeVideoA11y(video) {
    if (video.closest('jewelry-care-video-player')) return;

    if (video.hasAttribute('aria-label')) {
      video.removeAttribute('aria-label');
    }

    if (video.getAttribute('role') === 'img') {
      video.removeAttribute('role');
    }

    if (!video.hasAttribute('aria-hidden')) {
      video.setAttribute('aria-hidden', 'true');
    }
  }

  function initVideo(video) {
    if (video.dataset.adaPauseInit) return;

    // Opt-out for sections that supply their own pause control. Autoplaying
    // video still needs one to satisfy WCAG 2.2.2, so this attribute is a
    // promise that the section provides it — not a way to drop the control.
    // The video is still marked as handled so nothing else picks it up later.
    if (video.closest('[data-ada-pause-skip]')) {
      video.dataset.adaPauseInit = '1';
      return;
    }

    video.dataset.adaPauseInit = '1';

    sanitizeVideoA11y(video);

    if (!video.id) {
      video.id = 'ada-video-' + (++counter);
    }

    // If a pause button already exists in the HTML (liquid-rendered), just wire it up
    var existing = document.querySelector('[aria-controls="' + video.id + '"]');
    if (existing) {
      wireBtn(existing, video);
      return;
    }

    // Otherwise inject a new button
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ada-video-pause-btn';
    btn.setAttribute('aria-controls', video.id);
    btn.setAttribute('aria-label', 'Pause video');
    btn.innerHTML = PAUSE_SVG;

    wireBtn(btn, video);

    // Videos inside aria-hidden containers: place the button outside so AT can reach it
    var parent = video.parentElement;
    var ariaHiddenParent = parent && parent.getAttribute('aria-hidden') === 'true' ? parent : null;

    if (ariaHiddenParent) {
      var posParent = ariaHiddenParent.parentElement;
      if (posParent && getComputedStyle(posParent).position === 'static') {
        posParent.style.position = 'relative';
      }
      ariaHiddenParent.insertAdjacentElement('afterend', btn);
    } else {
      if (parent && getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent && parent.appendChild(btn);
    }
  }

  function scanVideos(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('video').forEach(function (video) {
      if (video.closest('jewelry-care-video-player')) return;
      sanitizeVideoA11y(video);
      if (video.hasAttribute('autoplay')) initVideo(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanVideos(document); });
  } else {
    scanVideos(document);
  }

  // Handle videos added dynamically (e.g. lazy-loaded sliders)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VIDEO') {
          if (!node.closest('jewelry-care-video-player')) {
            sanitizeVideoA11y(node);
            if (node.hasAttribute('autoplay')) initVideo(node);
          }
        } else if (node.querySelectorAll) {
          node.querySelectorAll('video').forEach(function (video) {
            if (video.closest('jewelry-care-video-player')) return;
            sanitizeVideoA11y(video);
            if (video.hasAttribute('autoplay')) initVideo(video);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
